import { useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Icons from "../../assets/icons/index.jsx";
import Images from "../../assets/images/index.jsx";
import {
  GET_ALL_Video,
  GET_Continue_QB,
  GET_Free_QB,
} from "../../gql/queries.jsx";
import { getPercentage, getqbPercentage, trimText } from "../../utils/index.js";
import { qb_new, firebaseData } from "../../firebase/index.jsx";
import NoDataFound from "../common/NoDataFound/NoDataFound";
import { Authorization, authorizationCheck } from "../../utils/logout.jsx";
import Loader from "../common/Loader/Loader.jsx";
import { decrypt } from "../../utils/crypto.jsx";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong.jsx";
import ConnectionError from "../common/NoDataFound/ConnectionError.jsx";
export default function QbLayer() {
  const completePathUrl = useLocation();
  const navigate = useNavigate();
  const [config, setConfig] = useState({});
  const [remote, setRemotedata] = useState();
  const [remoteLoading, setRemoteLoading] = useState(true);
  const [course, setCourse] = useState(
    JSON.parse(decrypt(localStorage.getItem("profileDetails")))
  );
  const packageStatus = JSON.parse(
    decrypt(localStorage.getItem("packageStatus"))
  );
  const query1 = useQuery(GET_ALL_Video, {
    variables: {
      courseName: course.preparingFor,
      version: 400,
      status: true,
      contentType: "qb",
      isRoot: true,
    },
    fetchPolicy: "network-only",
  });
  //moengage
  useEffect(() => {
    if (course?.preparingFor) {

    }
  }, [course?.preparingFor]);

  const query2 = useQuery(GET_Free_QB, {
    variables: {
      courseName: [course.preparingFor],
      page: 1,
      limit: 3,
    },
    fetchPolicy: "network-only",
  });
  const query3 = useQuery(GET_Continue_QB, {
    variables: {
      courseName: course.preparingFor,
    },
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    const getConfigData = async () => {
      try {
        const remoteData = await firebaseData("qbank_new"); // Replace 'your_config_key' with the actual key for the configuration value you want
        setConfig(remoteData);
        setRemotedata(remoteData.split(","));
        setRemoteLoading(false);
      } catch (error) {
        console.error("Error fetching remote data:", error);
        setRemoteLoading(false);
      }
    };

    if (typeof window !== "undefined") {
      getConfigData();
    }
  }, []);

  if (query1.loading || query2.loading || query3.loading) {
    return (
      <>
        <Loader />
      </>
    );
  }
  if (query1.error || query2.error || query3.error) {
    if (
      query1.error.graphQLErrors.some(
        (e) => e.extensions?.code === "UNAUTHENTICATED"
      ) ||
      query2.error.graphQLErrors.some(
        (e) => e.extensions?.code === "UNAUTHENTICATED"
      ) ||
      query3.error.graphQLErrors.some(
        (e) => e.extensions?.code === "UNAUTHENTICATED"
      )
    ) {
      authorizationCheck(navigate);
    } else if (
      query1.error.graphQLErrors.some(
        (e) => e.extensions?.code === "INTERNAL_SERVER_ERROR"
      ) ||
      query2.error.graphQLErrors.some(
        (e) => e.extensions?.code === "INTERNAL_SERVER_ERROR"
      ) ||
      query3.error.graphQLErrors.some(
        (e) => e.extensions?.code === "INTERNAL_SERVER_ERROR"
      )
    ) {
      return (
        <>
          <div className="main_wrapper">
            <div className="col-lg-12">
              <SomethingWentWrong pathName={completePathUrl.pathname} />
            </div>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="main_wrapper">
            <div className="col-lg-12">
              <ConnectionError pathName={completePathUrl.pathname} />
            </div>
          </div>
        </>
      );
    }
    console.log(query1.error.graphQLErrors);
    console.log(query2.error.graphQLErrors);
    console.log(query3.error.graphQLErrors);
  }
  let resourcelist = [];
  query1.data &&
    query1.data.layers.map((obj) => {
      if (
        obj.layerType === "resource_list" &&
        course.preparingFor === "NEET PG Program"
      ) {
        if (obj.subLayers.length !== 0) {
          resourcelist = obj.subLayers;
          return;
        } else {
          resourcelist = [];
          return;
        }
      }
      if (
        obj.layerType === "resource_list" &&
        course.preparingFor !== "NEET PG Program"
      ) {
        if (obj.subLayers.length !== 0) {
          resourcelist = obj.subLayers;
          return;
        } else {
          resourcelist = [];
          return;
        }
      } else if (
        obj.layerType === null &&
        course.preparingFor !== "NEET PG Program"
      ) {
        resourcelist.push(obj);
        return;
      }
    });

  let subjectlist;
  query1.data &&
    query1.data.layers
      .slice()
      .sort((a, b) => (a.position > b.position ? 1 : -1))
      .map((obj) => {
        if (obj.layerType === "subject_list") {
          subjectlist = obj.subLayers;
          return;
        }
      });

  let subject;
  query1.data &&
    query1.data.layers
      .slice()
      .sort((a, b) => (a.position > b.position ? 1 : -1))
      .map((obj) => {
        if (obj.layerType === "subject_list") {
          subject = obj;
          return;
        }
      });
  let resource;
  query1.data &&
    query1.data.layers
      .slice()
      .sort((a, b) => (a.position > b.position ? 1 : -1))
      .map((obj) => {
        if (obj.layerType === "resource_list" && obj.subLayers.length != 0) {
          resource = obj;
          return;
        }
      });

  const setSubject = (id) => {
    localStorage.setItem("subject", id);
  };
  return (
    <>
      {
        <div className="main_wrapper">
          <div className="breadcrumbs">
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Home</a>
              </li>
              <li className="breadcrumb-item active">
                <a>QBank</a>
              </li>
            </ul>
          </div>
          <section className="videoLayer_wrapper qbanks_wrapper section_side_padding">
            <div className="row">
              <div className="col-lg-8 col-md-7 col-sm-12">
                {query1.data != undefined &&
                  subjectlist &&
                  subjectlist.length != 0 && (
                    <div className="subjects_wrapper">
                      <div className="subjects_header">
                        <h6>{subject && subject.title}</h6>
                        <p>{subject && subject.description}</p>
                      </div>
                      <div className="all_subjects_name_wrapper">
                        <ul
                          type="none"
                          className="subjects_child d-flex flex-wrap"
                        >
                          {subjectlist &&
                            subjectlist
                              .slice()
                              .sort((a, b) =>
                                a.position > b.position ? 1 : -1
                              )
                              .map((d, i) => (
                                <li>
                                  <div className="subject_main_list d-flex align-items-center">
                                    <div className="subject_img_wrap d-flex align-items-center">
                                      <figure className="subject_img">
                                        <img
                                          src={
                                            d.icon ? d.icon : Images.defaultImg
                                          }
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </figure>
                                      <div
                                        className="subject_details"
                                        onClick={() => setSubject(d._id)}
                                      >
                                        <Link to={d._id}>
                                          {remote &&
                                            remote.includes(d?.title) && (
                                              <h6>
                                                {d?.title} <span>New</span>
                                              </h6>
                                            )}
                                          {remote &&
                                            !remote.includes(d?.title) && (
                                              <h6>{d?.title}</h6>
                                            )}
                                          <p>{d.author ? d.author.name : ""}</p>
                                        </Link>
                                      </div>
                                    </div>
                                    {getPercentage(d) !== 0 && (
                                      <div className="progressbar_wraper d-flex align-items-center">
                                        <div className="progress_details">
                                          <span>{`${getPercentage(d)}%`}</span>
                                          <div className="progress">
                                            <div
                                              className="progress-bar"
                                              style={{
                                                width: `${getPercentage(d)}%`,
                                              }}
                                            ></div>
                                          </div>
                                        </div>
                                        <div className="right_arrow">
                                          <img
                                            src={Icons.VideoArrow}
                                            alt=""
                                            className="img-fluid"
                                          />
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </li>
                              ))}
                          {/* <li>
										<div className="subject_main_list d-flex align-itmes-center">
											<div className="subject_img_wrap d-flex align-items-center">
												<figure className="subject_img">
													<img src={Icons.Micro} alt="" className="img-fluid" />
												</figure>
												<div className="subject_details">
													<h6>Microbiology</h6>
													<p>Dr.Ashwani Kumar</p>
												</div>
											</div>
											<div className="progressbar_wraper d-flex align-items-center">
												<div className="progress_details">
													<span>40%</span>
													<div className="progress">
														<div className="progress-bar" style={{ width: "30%" }}></div>
													</div>
												</div>
												<div className="right_arrow">
													<img src={Icons.VideoArrow} alt="" className="img-fluid" />
												</div>
											</div>
										</div>
									</li> */}
                        </ul>
                      </div>
                    </div>
                  )}
                {query1.data &&
                  query1.data.layers.length == 0 &&
                  query3.data &&
                  query3.data.continueLearningQb.length !== 0 &&
                  query2.data &&
                  query2.data.freeqb.qbBanks.length !== 0 && (
                    <NoDataFound></NoDataFound>
                  )}
                { }
                {/* {
								fire!=undefined&&
                        <div className="subjects_wrapper topics_concept_wrapper">
                            <div className="subjects_header">
                                <h6>Custom QBank</h6>
                                <p>Explore more content to help you prepare</p>
                            </div>
                            <div className="all_subjects_name_wrapper">
							<div className="concepts_img">
                                <img src={fire.subject_landing.concept.image}></img>
                            </div> */}
                {/* .......................... */}
                {/* <div className="row align-items-center">
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="how_to_use">
                                            <ul type="none" className="use_child_list">
                                                <li>Create your own question bank</li>
                                                <li>Share question code</li>
                                                <li>Analyze your level</li>
                                            </ul>
                                            <div className="learn_concept_btn">
                                                <a href="/" className="btn_learn">Create Custom QB <img src={Icons.ArrowBlue} alt="Arrow" className="img-fluid"/></a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="concepts_img text-center">
                                            <img src={Images.QbBanner} alt="" className="img-fluid"/>
                                        </div>
                                    </div>
                                </div> */}
                {/* .............. */}
                {/* </div>
                        </div>
					    } */}
                {query1.data != undefined &&
                  resourcelist &&
                  resourcelist.length != 0 && (
                    <div className="other_reasource_wrapper">
                      <div className="subjects_header">
                        <h6>
                          {resource && resource.title
                            ? resource.title
                            : "All Resources"}
                        </h6>
                        <p>
                          {resource && resource.description
                            ? resource.description
                            : "All resource description"}
                        </p>
                      </div>
                      <div className="resource_main">
                        <div className="row">
                          {resourcelist &&
                            resourcelist
                              .slice()
                              .sort((a, b) =>
                                a.position > b.position ? 1 : -1
                              )
                              .map((d, i) => (
                                <div className="col-lg-4 col-md-4 col-sm-12">
                                  <Link to={`QbOtherResource/${d._id}`}>
                                    <div className="resource_card d-flex">
                                      <div className="resource_img_detail">
                                        <figure className="res_img">
                                          <img
                                            src={
                                              d.icon
                                                ? d.icon
                                                : Images.defaultImg
                                            }
                                            alt=""
                                            className="img-fluid"
                                          />
                                        </figure>
                                        <h6>{d?.title}</h6>
                                        <p>
                                          {trimText(d)
                                            ? `${trimText(d)}...`
                                            : ""}
                                        </p>
                                      </div>
                                      <div className="res_arrow">
                                        <img
                                          src={Icons.VideoArrow}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                              ))}
                          {/* <div className="col-lg-4 col-md-4 col-sm-12">
										<div className="resource_card d-flex">
											<div className="resource_img_detail">
												<figure className="res_img">
													<img src={Images.Res3} alt="" className="img-fluid" />
												</figure>
												<h6>Grand Test Videos</h6>
												<p>Solution videos of all Grand Tests</p>
											</div>
											<div className="res_arrow">
												<img src={Icons.VideoArrow} alt="" className="img-fluid" />
											</div>
										</div>
									</div> */}
                          {/* <div className="col-lg-4 col-md-4 col-sm-12">
										<div className="resource_card d-flex">
											<div className="resource_img_detail">
												<figure className="res_img">
													<img src={Images.Res4} alt="" className="img-fluid" />
												</figure>
												<h6>Recall Question Videos</h6>
												<p>Solution videos of all previous year tests</p>
											</div>
											<div className="res_arrow">
												<img src={Icons.VideoArrow} alt="" className="img-fluid" />
											</div>
										</div>
									</div>
									<div className="col-lg-4 col-md-4 col-sm-12">
										<div className="resource_card d-flex">
											<div className="resource_img_detail">
												<figure className="res_img">
													<img src={Images.Res5} alt="" className="img-fluid" />
												</figure>
												<h6>DBMCI Live</h6>
												<p>Recordings of all DBMCI Live sessions</p>
											</div>
											<div className="res_arrow">
												<img src={Icons.VideoArrow} alt="" className="img-fluid" />
											</div>
										</div>
									</div> */}
                        </div>
                      </div>
                    </div>
                  )}
              </div>
              <div className="col-lg-4 col-md-5 col-sm-12">
                <div className="videos_wrapper">
                  {query3.data &&
                    query3.data.continueLearningQb.length != 0 && (
                      <div className="recommended_video_wrapper Free_videos_wrapper">
                        <div className="subjects_header">
                          <h6>Continue QBank</h6>
                          <div className="view_all_text d-flex align-items-center">
                            <div className="main_paragraph">
                              <p>Resume your question bank</p>
                            </div>
                          </div>
                        </div>
                        <div className="recommend_video_details">
                          <ul type="none" className="recommend_list">
                            {query3.data &&
                              query3.data.continueLearningQb
                                .slice(0, 5)
                                .map((d, i) => (
                                  <li>
                                    <Link
                                      to={`/qblayer/qbinstructions/${d.questionbank?._id
                                        }/${"content"}`}
                                    >
                                      <div className="recommend_list_main d-flex align-items-center">
                                        <figure className="user_img pos_rel">
                                          <img
                                            src={Images.Qbmark}
                                            alt=""
                                            className="img-fluid"
                                          />

                                          {d?.questionbank?.purchaseStatus !==
                                            0 && (
                                              <figcaption className="free_tag">
                                                <span>
                                                  <img
                                                    src={Icons.Lock}
                                                    alt="Lock"
                                                    className="img-fluid"
                                                  />
                                                  Pro
                                                </span>
                                              </figcaption>
                                            )}
                                          {d?.questionbank?.purchaseStatus ===
                                            0 &&
                                            packageStatus?.isTrialUser ===
                                            false &&
                                            packageStatus?.activePackageLength ===
                                            0 && (
                                              <figcaption className="free_tag">
                                                <span>Free</span>
                                              </figcaption>
                                            )}
                                          {/* <span><img src={Icons.Lock} alt="Lock" className='img-fluid'/> Pro</span> */}

                                          <span className="text_qb">QB</span>
                                        </figure>
                                        <div className="recommend_list_content">
                                          <div className="continue_qbanks_wrapper d-flex align-items-baseline">
                                            <div className="continue_ttl">
                                              <h6>{d?.questionbank?.title}</h6>
                                            </div>
                                            <div className="qbanks_rating">
                                              <span>
                                                <img
                                                  src={Icons.Star}
                                                  alt="Star"
                                                  className="img-fluid"
                                                />{" "}
                                                {d?.questionbank?.rating}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="progress_details d-flex align-items-center">
                                            <div className="timer_progress d-flex align-items-center">
                                              <div className="progress">
                                                <div
                                                  className="progress-bar"
                                                  style={{
                                                    width: `${getqbPercentage(
                                                      d?.questionbank
                                                    )}%`,
                                                  }}
                                                ></div>
                                              </div>
                                              <div className="progress_text">
                                                <p>
                                                  <span>
                                                    {
                                                      d?.questionbank?.progress
                                                        ?.questions?.length
                                                    }
                                                    /
                                                  </span>
                                                  {
                                                    d?.questionbank?.questionIds
                                                      ?.length
                                                  }{" "}
                                                  Questions
                                                </p>
                                              </div>
                                            </div>
                                            <div className="rightArrow_icn">
                                              <img
                                                src={Icons.QbRightArrow}
                                                alt="Play"
                                                className="img-fluid"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Link>
                                  </li>
                                ))}
                            {/* <li>
												<div className="recommend_list_main d-flex align-items-center">
													<figure className="user_img pos_rel">
														<img src={Images.Qbmark} alt="" className="img-fluid" />
														<figcaption className="free_tag">
															<span><img src={Icons.Lock} alt="Lock" className='img-fluid'/> Pro</span>
														</figcaption>
														<span className="text_qb">QB</span>
													</figure>
													<div className="recommend_list_content">
														<div className="continue_qbanks_wrapper d-flex align-items-baseline">
															<div className="continue_ttl">
																<h6>Cranial Nerve Nuclei and Columns</h6>
															</div>
															<div className="qbanks_rating">
																<span>
																	<img src={Icons.Star} alt="Star" className="img-fluid" /> 5.0
																</span>
															</div>
														</div>
														<div className="progress_details d-flex align-items-center">
															<div className="timer_progress d-flex align-items-center">
																<div className="progress">
																	<div className="progress-bar" style={{ width: "30%" }}></div>
																</div>
																<div className="progress_text">
																	<p><span>12/</span>21 Questions</p>
																</div>
															</div>
															<div className="rightArrow_icn">
																<img src={Icons.QbRightArrow} alt="Play" className="img-fluid" />
															</div>
														</div>
													</div>
												</div>
											</li> */}
                          </ul>
                        </div>
                      </div>
                    )}
                  {packageStatus?.isTrialUser === false &&
                    packageStatus?.activePackageLength === 0 &&
                    query2.data &&
                    query2.data.freeqb.qbBanks.length != 0 && (
                      <div className="recommended_video_wrapper Free_videos_wrapper">
                        <div className="subjects_header">
                          <h6>Free QBank</h6>
                          <div className="view_all_text d-flex align-items-center">
                            <div className="main_paragraph">
                              <p>Resume your question bank</p>
                            </div>
                            <div className="view_text">
                              <Link to={`/view/all/freeqb`}>
                                <p>
                                  <a href="/">View All</a>
                                </p>
                              </Link>
                            </div>
                          </div>
                        </div>
                        <div className="recommend_video_details">
                          <ul type="none" className="recommend_list">
                            {query2.data &&
                              query2.data.freeqb.qbBanks.map((d, i) => (
                                <li>
                                  <Link
                                    to={`/qblayer/qbinstructions/${d?._id
                                      }/${"content"}`}
                                  >
                                    <div className="recommend_list_main d-flex align-items-center">
                                      <figure className="user_img pos_rel">
                                        <img
                                          src={Images.Qbmark}
                                          alt=""
                                          className="img-fluid"
                                        />

                                        {d?.purchaseStatus !== 0 && (
                                          <figcaption className="free_tag">
                                            <span>
                                              <img
                                                src={Icons.Lock}
                                                alt="Lock"
                                                className="img-fluid"
                                              />
                                              Pro
                                            </span>
                                          </figcaption>
                                        )}
                                        {d?.purchaseStatus === 0 &&
                                          packageStatus?.isTrialUser ===
                                          false &&
                                          packageStatus?.activePackageLength ===
                                          0 && (
                                            <figcaption className="free_tag">
                                              <span>Free</span>
                                            </figcaption>
                                          )}

                                        <span className="text_qb">QB</span>
                                      </figure>
                                      <div className="recommend_list_content">
                                        <div className="continue_qbanks_wrapper d-flex align-items-baseline">
                                          <div className="continue_ttl">
                                            <h6>{d?.title}</h6>
                                          </div>
                                          <div className="qbanks_rating">
                                            <span>
                                              <img
                                                src={Icons.Star}
                                                alt="Star"
                                                className="img-fluid"
                                              />
                                              {d?.rating}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="progress_details d-flex align-items-center">
                                          <div className="timer_progress d-flex align-items-center">
                                            <div className="progress">
                                              <div
                                                className="progress-bar"
                                                style={{
                                                  width: `${getqbPercentage(
                                                    d
                                                  )}%`,
                                                }}
                                              ></div>
                                            </div>
                                            <div className="progress_text">
                                              <p>
                                                <span>
                                                  {d.progress
                                                    ? d?.progress?.questions
                                                      ?.length
                                                    : 0}
                                                  /
                                                </span>
                                                {d?.questionIds?.length}{" "}
                                                Questions
                                              </p>
                                            </div>
                                          </div>
                                          <div className="rightArrow_icn">
                                            <img
                                              src={Icons.QbRightArrow}
                                              alt="Play"
                                              className="img-fluid"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Link>
                                </li>
                              ))}
                            {/* <li>
												<div className="recommend_list_main d-flex align-items-center">
													<figure className="user_img pos_rel">
														<img src={Images.Qbmark} alt="" className="img-fluid" />
														<figcaption className="free_tag">
															<span><img src={Icons.Lock} alt="Lock" className='img-fluid'/> Pro</span>
														</figcaption>
														<span className="text_qb">QB</span>
													</figure>
													<div className="recommend_list_content">
														<div className="continue_qbanks_wrapper d-flex align-items-baseline">
															<div className="continue_ttl">
																<h6>Cranial Nerve Nuclei and Columns</h6>
															</div>
															<div className="qbanks_rating">
																<span>
																	<img src={Icons.Star} alt="Star" className="img-fluid" /> 5.0
																</span>
															</div>
														</div>
														<div className="progress_details d-flex align-items-center">
															<div className="timer_progress d-flex align-items-center">
																<div className="progress">
																	<div className="progress-bar" style={{ width: "30%" }}></div>
																</div>
																<div className="progress_text">
																	<p><span>12/</span>21 Questions</p>
																</div>
															</div>
															<div className="rightArrow_icn">
																<img src={Icons.QbRightArrow} alt="Play" className="img-fluid" />
															</div>
														</div>
													</div>
												</div>
											</li> */}
                          </ul>
                        </div>
                      </div>
                    )}
                </div>
              </div>
              <div className="col-lg-12">
                {query1.data &&
                  query1.data.layers.length == 0 &&
                  query3.data &&
                  query3.data.continueLearningQb &&
                  query2.data &&
                  query2.data.freeqb.qbBanks && <NoDataFound></NoDataFound>}
              </div>
            </div>
          </section>
        </div>
      }
    </>
  );
}
